// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__xq-hP"};